import { LanguageOptions } from "../../Base/LanguageOptions";
import { MapPoi } from "../Base/MapPoi";
import { MapPoiError } from "../Base/MapPoiError";
import { MapPoiWarning } from "../Base/MapPoiWarning";

export interface ManhuntMapPoi extends MapPoi {
  challenge: PoiChallenge;
  map_mods: MapMods;
  default_fx?: { [key: string]: number };
  default_content: PoiDefaultContent;
  witness: PoiWitness;
  issues?: Issues;
}

export interface Issues {
  warn?: MapPoiWarning;
  err?: MapPoiError;
}

export interface Issues {
  warn?: MapPoiWarning;
  err?: MapPoiError;
}

export interface PoiChallenge {
  active: boolean;
  content: {
    h_thumb: string;
    img: string;
    txt: LanguageOptions;
    audio?: LanguageOptions;
    video?: LanguageOptions;
  };
  fail_timeout_s: number;
  max_tries: number;
  on_fail: PoiResultFX;
  on_incorrect: PoiResultFX;
  on_success: PoiResultFX;
  puzzle: PoiPuzzle;
}

interface PoiResultFX {
  active: boolean;
  fx?: { [key: string]: number };
}

interface PoiPuzzle {
  q?: {
    txt: LanguageOptions;
    pins?: number;
    img: string;
    sliceImg?: string;
    numeric?: boolean;
    difficulty?: number;
    audio?: LanguageOptions;
    video?: LanguageOptions;
  };
  a?: {
    a0: {
      txt: LanguageOptions;
      correct: boolean;
    };
    a1?: {
      txt: LanguageOptions;
      correct: boolean;
    };
    a2?: {
      txt: LanguageOptions;
      correct: boolean;
    };
  };
  type: PUZZLE_TYPE;
}

export interface PoiWitness {
  active: boolean;
  guilt: boolean;
  suspect: boolean;
  content: { [key: string]: PoiWitnessContent };
}

export interface PoiWitnessContent {
  hint?: {
    txt: LanguageOptions;
  };
  inf?: {
    txt: LanguageOptions;
  };
  wit_q?: {
    [key: string]: {
      a: LanguageOptions;
      q: LanguageOptions;
    };
  };
  main: PoiBasicContent;
  slug?: string;
  triggers?: {
    btn_label?: {
      txt: LanguageOptions;
    };
    inv_req?: { [key: string]: number };
    target_id?: string;
  };
}

export interface MapMods {
  active: boolean;
  type: string;
  targetedBy?: {
    runaway?: { [key: string]: boolean };
    trigger?: { [key: string]: boolean };
  };
  set_self_inactive: boolean;
  runaway?: MapMod;
  trigger_list?: { [key: string]: boolean };
}

export interface PoiBasicContent {
  h_thumb: string;
  img: string;
  txt: LanguageOptions;
  video?: LanguageOptions;
  audio?: LanguageOptions;
}

export interface PoiDefaultContent extends PoiBasicContent {
  persist: boolean;
}

interface MapMod {
  on_fail: PoiResultFX;
  on_success: PoiResultFX;
  targets?: { [key: string]: boolean };
  timeout_s: number;
}

enum PUZZLE_TYPE {
  MULTI_CHOICE = "multi_trivia",
  CBREAKER = "code_breaker",
  SLICE = "slice9",
  LPICK = "lockpick",
}

enum MAPMOD_TYPE {
  RUNAWAY = "runaway",
  TRIGGER = "trigger",
}

export { PUZZLE_TYPE, MAPMOD_TYPE };
